export default {
  // host: "http://www.smtrap.com/",
  host: "",
};



// WEBPACK FOOTER //
// ./src/host.js